import { parseData } from '@/api/common';
import { getSuggestions } from '@/api/suggestion';

import { logger } from '@/util/logger';

window.suggestSelectionControls = {};
/* eslint-disable indent */
const $ = window.$;

export default function SuggestSelectionAsync(id, settings) {
    this.id = id;
    this.s = settings || {};

    this.$outer;
    this.$textbox;
    this.$suggestions;

	var _strSeedOptions = ''; // show top 10 options if 0 matches
    var _lastQuery = '';
    var _textBoxClass = '.js-suggestselection-textbox';
    var _suggestionsWrapperClass = '.js-suggestselection-suggestions';
    var _selectionClass = '.js-suggestselection-select';
    var _hideTimer = null;

    function _setSelectedValue(strVal) {
        //remove formatting tokens. removes multiple backslashes followed by a single quote and replaces with single quote  
        strVal = strVal.replace(/(\\\\|\\)'/g, "'");
		this.$textbox[0].value = strVal;
    }

    function _createSuggestionItem(val, index){
        let el = document.createElement('div');
        el.innerHTML = val;
        el.className = 'SelectionsDivItem ' + _selectionClass.replace('.','');
        el.setAttribute('data-value', val.replace(/(['"])/g, '\\$1'));
        el.setAttribute('data-index', index);
        el.tabIndex = -1;
        
        return el;
    }
    // comes with seed options (top 10)
    function _renderOptions(strOptions) {
        const elSuggestions = this.$suggestions[0];
        elSuggestions.innerHTML = '';

        if (strOptions.length === 0) {
			this.hideSuggestions(true);
            return;
        }
        
		const arrOptions = strOptions.split('{||}');
		const len = arrOptions.length;
        let frag = document.createDocumentFragment();

        for (let i = 0; i < len; i++) {
            let objItem = _createSuggestionItem(arrOptions[i], i);
            frag.appendChild(objItem);
        }
        
		elSuggestions.appendChild(frag);
		
		this.showSuggestions();
    }  
    function _$getFirstSuggestion() {
        // if no suggestions, return textbox
        return this.$suggestions.find(_selectionClass).first();
	}


    function _getSuggestions() {
        const that = this;
        const strQuery = this.$textbox.val();
		
		if (strQuery === '') {
			if (_strSeedOptions.length > 0) {
				_renderOptions.call(that, _strSeedOptions);
			}
			return Promise.resolve('done');
		}

		if (_lastQuery === strQuery) {
			this.showSuggestions();
			return Promise.resolve('done');
		}

        return getSuggestions({
            OptionsType: that.s.type,
            Query: strQuery
        })
            .then(parseData)
            .then((strResults) => {
				_lastQuery = strQuery;
				_renderOptions.call(that, strResults);
            })
            .catch(logger.error);
    }

    function _handleTextBoxKeydown(e){
        switch (e.which) {
            case 13:
                // get results of debounced call now
                this.getSuggestionsDebounced.flush();
                e.preventDefault();

                break;
            case 38:
                // up key
                this.hideSuggestions();
                e.preventDefault();
                break;
            case 40:
				// down key
				// focus first suggestion if there is one
				if (_$getFirstSuggestion.call(this).length) {
					this.showSuggestions();
					_$getFirstSuggestion.call(this).focus();
					e.preventDefault();
				}
                break;
            case 9:
                // tab key, do nothing
                break;
            default: 
                // do debounced search
                this.getSuggestionsDebounced();
                break;
        }
    }

    function _handleSuggestionKeydown(e, elem) {
        let index = elem.getAttribute('data-index');

        switch (e.which) {
            // enter
            case 13:
                _setSelectedValue.call(this, elem.getAttribute('data-value'));
                this.hideSuggestions();
                // select and close
                break;
            // spacebar
            case 32: 
                _setSelectedValue.call(this, elem.getAttribute('data-value'));
                // select
                break;
            // down/right arrows
            case 39:
            case 40:
                $(elem).next().focus();
                break;
            //left/up arrows
            case 38:
            case 37:
                // focus previous suggestion unless we are on the first one
                if (index == 0) {
                    this.$textbox.focus();
                } else {
                    $(elem).prev().focus();
                }

                break;
            default:
                // do nothing
                break;
        }

            e.preventDefault();
    }

    function _attachEvents() {
        var that = this;
		this.$outer
			.on('keydown.suggest-select-async', _selectionClass, function(e) {
                const elem = this;
                _handleSuggestionKeydown.call(that, e, elem);			
			})
			.on('click.suggest-select-async', _selectionClass, function() {
                // select and close
                _setSelectedValue.call(that, this.getAttribute('data-value'));
                that.hideSuggestions();
            });
            
        this.$outer
            .on('focus.suggest-select-async', _textBoxClass, function(){
				_getSuggestions.call(that);
            })
            .on('keydown.suggest-select-async', _textBoxClass, function(e) {
                const strQuery = e.target.value;
                _handleTextBoxKeydown.call(that, e, strQuery);
            });

        this.$outer
            .on('focusin.suggest-select-async', function(){
                window.clearTimeout(_hideTimer);
                that.showSuggestions();
            })
            .on('focusout.suggest-select-async', function(){
                that.hideSuggestions(true);
            });
    }

    function _detachEvents() {
        this.$outer.off('.suggest-select-async');
	}
	
	function _hideSuggestionsImmediate() {
		this.$suggestions
			.hide()
			.css({'visibility':'hidden'});
	}

    this.showSuggestions = function() {
		// only show if there is at least one option to show
		if (this.$suggestions.children().length) {
			this.$suggestions
            .css({'visibility':'visible'})    
            .fadeIn(75);
		}
    };
    
    this.hideSuggestions = function(booDelay) {
        var that = this;
        _hideTimer = window.setTimeout(function(){
            that.$suggestions.fadeOut(75);
    
            window.setTimeout(function(){
                _hideSuggestionsImmediate.call(that);
            }, 75);
        }, booDelay ? 0 : 100);

	};
	
    this.getSuggestionsDebounced = window.debounce(_getSuggestions, 250, {trailing: true});
    
	this.init = function(strSeedOptions) {
        this.$outer = $('#' + this.id);
        this.$textbox = this.$outer.find(_textBoxClass);
        this.$suggestions = this.$outer.find(_suggestionsWrapperClass);

        if (!this.$outer.length) {
            logger.log('Warning: No suggest selection element found for id', this.id);
            return;
        }

        // remove inline events applied from WUC 
        this.$textbox.removeAttr('onkeyup onpaste oninput onfocus onblur onkeydown');
        this.$suggestions
            .removeAttr('onblur onfocus')
            .attr('tabindex', '-1');

        // make sure events do not get double attached;
        _detachEvents.call(this);

        if (strSeedOptions) {
            _strSeedOptions = strSeedOptions;
            _attachEvents.call(this);
            // render seed options;
        } else {
            // if no seed options that means there are NO suggestions, 
            // so this will function just like a regular text field
            // _strSeedOptions = strSeedOptions;
            // _renderOptions.call(this, _strSeedOptions);
            // _attachEvents.call(this);
        }
	};
}